import React from 'react';
import { UI_TAG, Divider, colors2 } from 'oolib';
import styled from 'styled-components';
import { ListItem } from './ListItem';


export const GroupHeader = styled.div`
  padding: 0.4rem 0.8rem;
  color: ${colors2.grey50};
  position: sticky;
  top: ${({groupHeaderStickyTop}) => groupHeaderStickyTop};
  width: 100%;
  background: white;
  /* z-index: 1000; */
`;

export const GroupDivider = styled.div`
  margin: 0.4rem 0 0.8rem 0;
`;


export const ListGroup = ({
  id,
  group,
  index,
  groupStartIndex = 0,
  value,
  focussedOp,
  scrollFocussedOpIntoView,
  optionsClassName,
  invert,
  S,
  observerRef,
  isMulti,
  isTagsStyle,
  groupHeaderStickyTop = 0,
  alignCheckbox="left",
  iconAfter,
  onDragStart,
  onDragOver,
  optimisticSelections,
  onChange
}) => {
  return (
    <div>
      {index > 0 && (
        <GroupDivider>
          <Divider />
        </GroupDivider>
      )}
      {group.display && (
      <GroupHeader groupHeaderStickyTop={groupHeaderStickyTop}>
        <UI_TAG>{group.display}</UI_TAG>
      </GroupHeader>
      )}
      {group.options.map((option, idx) => {
        // Calculate flat index for drag selection (groupStartIndex + local index)
        const flatIndex = groupStartIndex + idx;
        return (
          <ListItem
            key={option.value}
            option={option}
            isSelected={(!option.loading && value?.value === option.value)}
            isFocussed={focussedOp === idx}
            index={flatIndex}
            scrollFocussedOpIntoView={scrollFocussedOpIntoView}
            optionsClassName={optionsClassName}
            invert={invert}
            S={S}
            observerRef={group.options.length === idx + 1 ? observerRef : null}
            isMulti={isMulti}
            isTagsStyle={isTagsStyle}
            value={value}
            alignCheckbox={alignCheckbox}
            iconAfter={iconAfter}
            onDragStart={onDragStart}
            onDragOver={onDragOver}
            groupIndex={index}
            optimisticSelections={optimisticSelections}
            onChange={onChange}
          />
        );
      })}
    </div>
  );
};
